import { gql } from '@apollo/client';

export const UPSERT_RESULT_SHEET = gql`
  mutation upsertResultSheet($data: UpsertResultSheetInput!) {
    upsertResultSheet(data: $data) {
      id
    }
  }
`;

export const APPROVE_DENY_RESULT_SHEET = gql`
  mutation approveDenyResultSheet($where: ApproveDenyResultSheetWhereInput!, $data: ApproveDenyResultSheetInput!) {
    approveDenyResultSheet(where: $where, data: $data) {
      id
    }
  }
`;

export const RESULT_SHEET = gql`
  query result_sheet($where: result_sheet_bool_exp) {
    result_sheet(where: $where) {
      academicHeadRemark
      status
      batchClassId
      batchSubjectConfigurationId
      batch_subject_configuration {
        batch {
          courseId
        }
        subject {
          course_semester_subjects_subjects {
            course_semester {
              semester
              courseId
              id
            }
          }
        }
      }
      user_public {
        firstName
        lastName
        id
      }
      student_result_sheets {
        customMarks
        remark
        studentId
        student_results {
          batchSubjectExtraSlotId
          assessmentId
          firstAttemptMarks
          isFirstAttemptNYC
          secondAttemptMarks
          isSecondAttemptNYC
          thirdAttemptMarks
          isThirdAttemptNYC
        }
      }
    }
  }
`;

export const RESULT_SHEETS = gql`
  subscription result_sheets($where: result_sheet_bool_exp) {
    result_sheet(where: $where) {
      id
      status
      user_public {
        firstName
        lastName
        id
      }
      batch_subject_configuration {
        subject {
          name
          code
        }
      }
      batch_class {
        name
        batch {
          name
          course {
            code
            name
          }
        }
      }
    }
  }
`;

export const DELETE_RESULT_SHEET = gql`
  mutation delete_result_sheet($where: result_sheet_bool_exp!) {
    delete_result_sheet(where: $where) {
      affected_rows
    }
  }
`;
